import React from 'react';
import { motion } from 'framer-motion';

// Lightweight page transitions optimized for performance
export const pageTransitionVariants = {
  // Simple fade only
  fade: {
    initial: { opacity: 0 },
    animate: { 
      opacity: 1,
      transition: {
        duration: 0.2,
        ease: 'easeOut'
      }
    },
    exit: { 
      opacity: 0,
      transition: {
        duration: 0.15,
        ease: 'easeIn'
      }
    }
  },

  // Minimal slide without scale or blur
  slideMinimal: {
    initial: { 
      opacity: 0, 
      y: 20
    },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.25,
        ease: 'easeOut'
      }
    },
    exit: { 
      opacity: 0,
      transition: {
        duration: 0.15,
        ease: 'easeIn'
      }
    }
  }
};

// Minimal stagger animations
export const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      delayChildren: 0.05
    }
  }
};

export const itemVariants = {
  hidden: { opacity: 0, y: 10 },
  show: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: 0.2,
      ease: 'easeOut'
    }
  }
};

// Simplified page wrapper
export const PageTransition = ({ children, variant = 'fade' }) => (
  <motion.div
    initial="initial"
    animate="animate"
    exit="exit"
    variants={pageTransitionVariants[variant]}
    style={{ width: '100%' }}
  >
    {children}
  </motion.div>
);

// Container for staggered children
export const StaggerContainer = ({ children }) => (
  <motion.div
    variants={containerVariants}
    initial="hidden"
    animate="show"
    style={{ width: '100%' }}
  >
    {children}
  </motion.div>
);

// Individual staggered item
export const StaggerItem = ({ children }) => (
  <motion.div variants={itemVariants}>
    {children}
  </motion.div>
);

// No-op components for easy migration
export const ScrollReveal = ({ children }) => <>{children}</>;
export const SectionTransition = ({ children }) => <>{children}</>;
export const LuxuryReveal = ({ children }) => <>{children}</>;
export const CinematicTransition = ({ children }) => <>{children}</>;

export default {
  pageTransitionVariants,
  containerVariants,
  itemVariants,
  PageTransition,
  StaggerContainer,
  StaggerItem,
  ScrollReveal,
  SectionTransition
};